import type { Routes } from '../../shares/types';
import { SpinBasic } from './basic';

export const SPIN_ROUTES: Routes = {
	spin: {
		basic: SpinBasic,
	},
};
